// extracted by mini-css-extract-plugin
export var cdButton = "market-switcher-module--cd-button--d8c1c";
export var cdMarketSwitcherInput = "market-switcher-module--cd-market-switcher-input--f8700";
export var cdMarketSwitcherInputWrapper = "market-switcher-module--cd-market-switcher-input-wrapper--47bc2";
export var cdMarketSwitcherLink = "market-switcher-module--cd-market-switcher-link--130a3";
export var cdMarketSwitcherRow = "market-switcher-module--cd-market-switcher-row--97b1d";
export var cdMarketSwitcherTerm = "market-switcher-module--cd-market-switcher-term--a1e53";
export var cdMarketSwitcherTerms = "market-switcher-module--cd-market-switcher-terms--40c47";
export var cdMarketSwitcherTop = "market-switcher-module--cd-market-switcher-top--4a08a";
export var cdMarketSwitcherWrapper = "market-switcher-module--cd-market-switcher-wrapper--1e4f9";